import { useSelector } from 'react-redux'
import { useABVariant } from '../../../../utils/hooks'
import { AB_KEY, AB_VARIANT_VERSION } from '../../../../common/constants'
import { getIsSelectMode, setSelectMode } from '../../../../redux/bulk-inquiry'
import { useAppDispatch } from '../../../../redux/hooks'
import AnalyticsService from '../../../../services/analytics-service'
import { bulkInquiryPageCategories } from '../../../../services/analytics-service/categories'
import { bulkInquiryPageActions } from '../../../../services/analytics-service/actions'

interface UseBulkInquiryReturn {
    isEnabled: boolean
    isSelectMode: boolean
    toggleSelectMode: () => void
}

export const useBulkInquiry = (): UseBulkInquiryReturn => {
    const dispatch = useAppDispatch()

    const { isProvidedVariantActive } = useABVariant(AB_KEY.BULK_INQUIRY_SRL, AB_VARIANT_VERSION.ONE)
    const isEnabled = isProvidedVariantActive

    const isSelectMode = useSelector(getIsSelectMode)

    const toggleSelectMode = () => {
        const nextIsSelectMode = !isSelectMode
        AnalyticsService.trackEvent({
            category: bulkInquiryPageCategories.SRL,
            action: nextIsSelectMode
                ? bulkInquiryPageActions.TOGGLE_CLICKED_ON
                : bulkInquiryPageActions.TOGGLE_CLICKED_OFF,
        })
        dispatch(setSelectMode(nextIsSelectMode))
    }

    return { isEnabled, isSelectMode, toggleSelectMode }
}
